import React, { useState, useEffect, useCallback } from 'react'
import PropTypes from 'prop-types'
import { View, StyleSheet, TouchableOpacity } from 'react-native'
import Txt from '../../components/Txt'
import { useTheme } from '../../theming/ThemeProvider'

const FilterByBidAndBook = ({ handleBidAndBook, initialState, useHotFilter, hotValue, handleHotFilter }) => {
  const [state, setState] = useState(initialState)
  const [hot, setHot] = useState(hotValue)
  const { theme } = useTheme()
  const styles = useStyles(theme)

  const handleOnchage = value => {
    const idx = state.findIndex(i => i === value)
    let currentState = [...state]
    if (idx !== -1) {
      currentState.splice(idx, 1)
    } else {
      currentState = [...currentState, value]
    }

    setState(currentState)
    handleBidAndBook(currentState)
  }

  const handleHotChange = useCallback(() => {
    setHot(!hot)
    handleHotFilter(!hot)
  }, [handleHotFilter, hot])

  useEffect(() => {
    setState(initialState)
  }, [initialState])

  useEffect(() => {
    setHot(hotValue)
  }, [hotValue])

  const isSelected = value => state.length ? state.includes(value) : false

  return (
    <View style={styles.container}>
      <View style={styles.bidAndBook}>
        <TouchableOpacity
          activeOpacity={0.8}
          onPress={() => handleOnchage('bid')}
          style={[styles.button, { borderColor: theme.GOLDEN_GRASS }, isSelected('bid') && { backgroundColor: theme.GOLDEN_GRASS }]}
          testID='filterByBidButton'
          accessibilityLabel='filterByBidButton'
        >
          <Txt
            text='Bid'
            color={isSelected('bid') ? 'WHITE_TEXT' : 'GOLDEN_GRASS'}
            identity='body2'
          />
        </TouchableOpacity>
        <TouchableOpacity
          activeOpacity={0.8}
          onPress={() => handleOnchage('book')}
          style={[styles.button, { borderColor: theme.LOCHMARA }, isSelected('book') && { backgroundColor: theme.LOCHMARA }]}
          testID='filterByBookButton'
          accessibilityLabel='filterByBookButton'
        >
          <Txt
            text='Book'
            color={isSelected('book') ? 'WHITE_TEXT' : 'LOCHMARA'}
            identity='body2'
          />
        </TouchableOpacity>
      </View>
      {useHotFilter && (
        <View style={styles.hotFilter}>
          <TouchableOpacity
            activeOpacity={0.8}
            onPress={handleHotChange}
            style={[styles.button, { borderColor: theme.RED_ORANGE }, hot && { backgroundColor: theme.RED_ORANGE }]}
          >
            <Txt
              text='Hot'
              color={hot ? 'WHITE_TEXT' : 'RED_ORANGE'}
              identity='body2'
            />
          </TouchableOpacity>
        </View>
      )}
    </View>
  )
}

const useStyles = (theme) => StyleSheet.create({
  container: {
    flexDirection: 'row',
    marginBottom: 10,
    justifyContent: 'space-between'
  },
  bidAndBook: {
    flexDirection: 'row'
  },
  button: {
    paddingVertical: 3,
    paddingHorizontal: 20,
    marginRight: 10,
    borderWidth: 1,
    borderRadius: 20
  },
  hotFilter: {
    flexDirection: 'row'
  },
  divider: {
    width: 1,
    marginRight: 10,
    backgroundColor: theme.GEYSER
  }
})

FilterByBidAndBook.propTypes = {
  handleBidAndBook: PropTypes.func.isRequired,
  handleHotFilter: PropTypes.func,
  initialState: PropTypes.array.isRequired,
  useHotFilter: PropTypes.bool,
  hotValue: PropTypes.bool
}

export default FilterByBidAndBook
